/**
 * بوّابة جهاز لبلوكات الهوم: تخفي البلوك على الموبايل أو الديسكتوب
 * حسب إعداد `devices` في /admin/home-blocks-simple (كلاس CSS فقط — SSR-safe).
 */
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { getSimpleBlocks } from "@/utils/simpleBlocks.functions";
import { deviceVisibilityClass, HOME_BLOCK_SETTINGS_KEY } from "@/lib/simple-blocks";

export function useHomeBlockDevices() {
  const fetchFn = useServerFn(getSimpleBlocks);
  const { data } = useQuery({
    queryKey: ["home-simple-blocks-devices"],
    queryFn: () => fetchFn({ data: {} }),
    staleTime: 60_000,
  });
  return data?.blocks ?? {};
}

export function BlockDeviceGate({
  blockKey,
  children,
}: {
  blockKey: string;
  children: React.ReactNode;
}) {
  const blocks = useHomeBlockDevices();
  const settingsKey = HOME_BLOCK_SETTINGS_KEY[blockKey];
  const cls = settingsKey ? deviceVisibilityClass(blocks[settingsKey]?.devices) : "";
  if (!cls) return <>{children}</>;
  return <div className={cls}>{children}</div>;
}
